/* eslint-disable react/prefer-es6-class, react/sort-comp */
import React from 'react';
import { t } from 'es6/services/localization';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import SentenceTrainerSummaryMixin from 'es6/components/apps/mixins/sentence-trainer-summary';
import SoundPlayer, { SOUND_PLAYER_UNSTYLED } from 'es6/components/common/sound-player';
import MouseoverDictionary from 'iknow-mouseover-dictionary/react';

const SENTENCES_PER_ROW = 2;

export default React.createClass({
  displayName: 'SentenceTrainerSummaryBreakdownScreen',

  mixins: [SentenceTrainerSummaryMixin],

  propTypes: {
    onBack: React.PropTypes.func.isRequired,
    presentationResults: React.PropTypes.array.isRequired,
    sessionData: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <div className="screen screen-sentence-trainer-summary-breakdown">
        <div className="screen-content">
          <h2>{t('please review the sentences below')}</h2>

          <div className="scroll-container">
            <div className="sentences">
              {this._renderSentences()}
            </div>
          </div>
        </div>

        <Navigation>
          <NavButton focused onClick={this.props.onBack}>{t('js_iknow.back')}</NavButton>
        </Navigation>
      </div>
    );
  },

  /**
   * Renders the sentence and the result of the study.
   *
   * @param {Sentence} sentence
   * @param {Object}   result
   */
  _renderSentence(sentence, result) {
    return (
      <div key={sentence.getId()} className="sentence-content">
        {this._renderSoundPlayer(sentence)}

        <div className="cue-response-results">
          <div className="text">
            <MouseoverDictionary html={sentence.getText()} />
          </div>
          <div className="transliteration" dangerouslySetInnerHTML={{ __html: sentence.getTransliteration() }} />
          <div className="translation" dangerouslySetInnerHTML={{ __html: sentence.getTranslation() }} />

          <div className="result-summary">
            <span className="label">{t('misses:')}</span> <span className="value">{result.mistakes}</span>
            {' '}
            <span className="label">{t('hints:')}</span> <span className="value">{result.hints}</span>
          </div>
        </div>

        <div className="result-glyph">
          <span className={result.resultGlyph} />
        </div>
      </div>
    );
  },

  _renderSentences() {
    const { sessionData } = this.props;
    const sentenceTrainerResults = this._getSentenceTrainerResults();

    // Partition the sentences into rows and then render the
    // sentences into a sentence group.
    return sentenceTrainerResults.reduce((arr, sentence, i) => {
      if (i % SENTENCES_PER_ROW === 0) {
        arr.push([sentence]);
      } else {
        arr[arr.length - 1].push(sentence);
      }

      return arr;
    }, []).map((row, i) => {
      const sentences = row.map(result => {
        const sentence = sessionData.sentences[result.contentId];
        return this._renderSentence(sentence, result);
      });

      return (<div key={i} className="sentence-group">{sentences}</div>);
    });
  },

  _renderSoundPlayer(sentence) {
    const sound = sentence.sound;

    if (!sound) {
      return null;
    }

    return (
      <div className="sound-player-container">
        <SoundPlayer source={sound} variant={SOUND_PLAYER_UNSTYLED} />
      </div>
    );
  },
});
